import React, {useEffect, ReactElement} from 'react';
import {reportEvent} from '../reportEvent';

type Props = {
    /** Name of error report */
    name: string;
    /** ID string for tracing the event */
    requestMarker?: string;
    /** Any data to log server side, useful for Splunking and such */
    logData?: object;
    /** React child component to render */
    children?: ReactElement;
};

/**
 * Reports an Success event and renders any children.
 */
const SuccessReport = ({
    name,
    requestMarker,
    logData,
    children
}: Props): ReactElement | null => {
    useEffect(() => {
        reportEvent({name, requestMarker, logData}, 'SUCCESS');
    }, [name]);

    /** react-docgen can't auto create the Props table unless the function return a fragment.
     * See https://github.com/reactjs/react-docgen/issues/336
     */
    return <>{children}</> || null;
};

/**
 * Reports an Eroor event and renders any children.
 */
const ErrorReport = ({
    name,
    requestMarker,
    logData,
    children
}: Props): ReactElement | null => {
    useEffect(() => {
        reportEvent({name, requestMarker, logData}, 'ERROR');
    }, [name]);
    return <>{children}</> || null;
};

export {SuccessReport, ErrorReport};
